import { forwardRef } from "react";
import { Button, cn } from "ui";
import { ArrowRightIcon } from "icons/outline";
import Link from "next/link";

type SectionProps = {
  id?: string;
  className?: string;
  children: React.ReactNode;
};

const SectionRoot = forwardRef<HTMLDivElement, SectionProps>(function Section(
  { id, className, children },
  ref
) {
  return (
    <section
      ref={ref}
      id={id}
      className={cn(
        "flex scroll-mt-[140px] flex-col gap-6 lg:scroll-mt-[100px]",
        className
      )}
    >
      {children}
    </section>
  );
});

const SectionTitle = ({
  children,
  viewMoreLink,
}: {
  children: React.ReactNode;
  viewMoreLink?: string;
}) => (
  <div className="flex items-center justify-between gap-1">
    <h2 className="text-lg font-medium text-foundations-boldest">{children}</h2>
    {viewMoreLink && (
      <Button variant="tertiary" size="xs" render={<Link href={viewMoreLink} />}>
        View more <ArrowRightIcon />
      </Button>
    )}
  </div>
);

export const Section = Object.assign(SectionRoot, {
  Title: SectionTitle,
});
